import type { ChakraProps } from '@chakra-ui/react';
import type { CoinMode } from '@ui/hooks/useCoinMode';
import getBgImage from '@ui/utils/getBgImageProps';

export const stakeBg: Record<CoinMode, Partial<ChakraProps>> = {
  cro: getBgImage('PATTERN_2'),
  atom: getBgImage('PATTERN_1_ATOM'),
  eth: getBgImage('PATTERN_STAKE_ETH'),
  tia: getBgImage('PATTERN_STAKE_TIA'),
};
